import React from 'react'
import { observer } from 'mobx-react'
import OwnedBoundary from './OwnedBoundary'
import SharedBoundary from './SharedBoundary'

const BoundaryPane = ({ boundary, group }) => {
  const isShared = group && group.share_type && group.share_type !== 'none'
  const canManage = isShared
    ? !!(boundary && boundary.is_owner)
    : !!(group && group.is_owner)
  return (
    canManage
      ? <OwnedBoundary boundary={boundary} group={group} />
      : <SharedBoundary boundary={boundary} group={group} />
  )
}

export default observer(BoundaryPane)
